<template>
  <div id="profile">
    <div class="container">
      <div class="top"v-if="!$store.state.isDesktop"></div>
      <div class="image" v-if="$store.state.isDesktop">
        <div class="circle">
<!--          <img v-if="$store.state.cogir" src="@/assets/img/icons/octo-white.png">-->
          <svgicon src="svg/user.svg" :width=150 :height=150 class="icon"></svgicon>
        </div>
      </div>
      <!-- <div class="tabs">
        <div class="tab active">Informations</div>
        <div class="tab">Paiement</div>
      </div> -->
<!--      <div class="edit" v-show="edit">-->
<!--        &lt;!&ndash; <input type="text" v-model="editPhone">-->
<!--        <label for="">{{ $t("user.phone") }}</label> &ndash;&gt;-->
<!--        <input type="text" v-model="editEmail">-->
<!--        <label>{{ $t("user.email") }}</label>-->
<!--        <div class="buttons">-->
<!--          <div class="btn btn-secondary" @click="edit = false">{{ $t("navigation.cancel") }}</div>-->
<!--          <div class="btn btn-primary" @click="save">{{ $t("navigation.save") }}</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="nonEdit content-right" v-show="!edit" v-if="User">
        <div class="title" v-if="$store.state.isDesktop && User.firstName && User.lastName">
          {{ User.firstName }} {{ User.lastName }}
        </div>
        
        <div class="section" v-if="Property && Property.address && lease">
          <div class="leftIcon">
            <svgicon src="svg/location.svg" :width=20 :height=20></svgicon>
          </div>
          <div class="content">
            <div class="subtitle">{{ $t("profile.location") }}</div>
            {{Property.address.full}}<br>
            {{$t('address.unit')}} {{lease.unitNumber}}<br>
            {{Property.address.city}}
            <span v-if="Property.address.state">
              ({{Property.address.state}})
            </span><br>
              {{Property.address.zip}}
          </div>
        </div>
  
        <div class="section" v-if="lease && lease.paymentNumber">
          <div class="leftIcon">
            <svgicon src="svg/piggy.svg" :width=20 :height=20></svgicon>
          </div>
          <div class="content">
            <div class="subtitle">{{ $t("profile.payment_number") }}</div>
            <div class="line">
              {{lease.paymentNumber}}
            </div>
          </div>
        </div>
  
        <div class="section" v-if="User.firstName && User.lastName">
          <div class="leftIcon">
            <svgicon src="svg/phone.svg" :width=20 :height=20></svgicon>
          </div>
          <div class="content">
            <div class="subtitle">{{ $t("profile.name") }}</div>
            {{ User.firstName }} {{ User.lastName }}
          </div>
        </div>
  
        <div class="section" v-if="User.phone">
          <div class="leftIcon">
            <img src="@/assets/img/icons/phone-grey.png">
          </div>
          <div class="content">
            <div class="subtitle">{{ $t("user.phone") }}</div>
            {{ User.phone }}
          </div>
        </div>
  
        <div class="section last" v-if="User.email">
          <div class="leftIcon">
            <svgicon src="svg/mail.svg" :width=20 :height=20></svgicon>
          </div>
          <div class="content">
            <div class="subtitle">{{ $t("user.email") }}</div>
            {{ User.email }}
          </div>
        </div>
  
        <div class="buttons">
          <div class="btn btn-secondary" @click="logout">{{ $t("user.logout") }}</div>
<!--           <div class="btn btn-primary" @click="startEdit">{{ $t("profile.edit") }}</div>-->
        </div>
  
      </div>
    </div>
  </div>
</template>

<script>

  import User from '../../core/User';
  import Property from "../../core/Property";
  import Lease from "../../core/Lease";

  export default {

    name: "profile",

    data() {
      return {
        edit: false,
        editPhone: "",
        editEmail: "",
        lease: null,
        Property,
        User
      };
    },

    mounted() {
      if (!User.token) {
        this.$router.replace("/login");
      }
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "profile.my",
        headerIcon: "/svg/user.svg"
      });
      this.loadLease();
    },

    methods: {
      logout() {
        User.logout();
        this.$router.push("/login");
      },
      startEdit() {
        this.editEmail = User.email;
        this.edit = true;
      },
      loadLease() {
        if (!User.lease) {
          return;
        }
        this.lease = new Lease();
        this.lease.get(User.lease);
      },
      save() {
        User.email = this.editEmail;
        let result = User.save();
        if (result) {
          this.edit = false;
        } else {
          // TODO - afficher une erreur
        }
      }
    }

  }

</script>

<style lang="scss" scoped>

  #profile {
    background-color: #f2f3f4;
  }

  .top {
    height: 180px;
    background-image: url(../assets/img/header-profile.png);
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .photo {
      width: 110px;
      height: 110px;
      border: 2px solid white;
      border-radius: 50%;
      margin-bottom: 10px;
    }
    .name {
      font-size: 20px;
      color: white;
      font-weight: 500;
    }
    .changePhoto {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  .tabs {
    height: 40px;
    display: flex;
    background-color: white;
    .tab {
      flex-grow: 1;
      flex-basis: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        font-weight: 500;
        box-shadow: inset 0 -4px 0 #bfc5c8;
      }
    }
  }

  .section {
    display: flex;
    padding: 20px 0;
    &:first-of-type {
      padding-top: 0;
    }
    &:not(:last-of-type):not(.last) {
      border-bottom: 1px solid #d9dcde;
    }
    .leftIcon {
      width: 20px;
      margin-right: 20px;
      padding-top: 6px;
      text-align: center;
      .svgicon {
        fill: #808b91;
      }
    }
    .content {
      flex-grow: 1;
    }
    .subtitle {
      color: #bfc5c8;
      text-transform: uppercase;
      font-size: 12px;
    }
    .line {
      display: flex;
      .grow {
        flex-grow: 1;
      }
    }
  }

  .buttons {
    display: flex;
    margin-top: 20px;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
      font-size: 14px;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  .nonEdit {
    padding: 20px;
  }

  .edit {
    padding: 20px;
    input {
      width: 100%;
    }
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {
  
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #profile {
      padding: 30px 60px 30px 60px;
    }
  
    .container{
      display:flex;
      //flex-direction:column;
      border-radius: 5px;
      background-color: white;
      flex-grow:1;
      overflow:hidden;
      .content-right {
        display:flex;
        flex-direction: column;
        flex-grow: 1.3;
        flex-basis:0;
      }
    }
  
    .title {
      font-size:24px;
      font-weight:600;
    }
    
    .image {
      display:flex;
      background-color: #dfe2e3;
      //background-image: url(../assets/img/header-profile.png);
      background-size: cover;
      background-position: center;
      flex-grow: 1;
      flex-basis:0;
      justify-content:center;
      align-items: center;
      .circle {
        opacity:60%;
        display:flex;
        width: 250px;
        height: 250px;
        background-color: #aaa;
        border-radius: 50%;
        border: solid 10px #ffffff;
        align-items: center;
        justify-content:center
      }
      
      img{
        opacity: 50%;
      }
    }
  
    .icon {
      fill: white;
      opacity: 30%;
    }

    .buttons {
      .btn {
        min-width:180px;
        flex-grow:0;
      }
    }
  }

</style>